import { del, patch, post, read } from '@/utils/request'
import type { BatchProcessingParams, BatchProcessingRes, DetailWithLogs, ListData } from 'bv-typings'
import type { MailSaleListItem } from '@/services/distributeMail/addressee'
import { paramsArray2Str, toggleTime } from '@/utils'


export type IMailReminderInfo = {
  id: string
  accountId: string	// 账户ID
  radRemindDate: string		// 日期
  disapprovalAdId: string		// 拒登AD_ID
  resellerName: string		// reseller_name
  adTotalRevenue: string		// ad_total_revenue
  policy: string		// policy
  advertiserName: string		// advertiser_name
  vertical: string		// vertical
  mediaVertical: string		// 媒体vertical
  accountStatus: string		// 账户状态
  landingUrl: string		// landing_url
  pcbm: string		// pcbm
  agency: string	// 代理
  advertiser: string		// advertiser
  saleName: string	// 销售
  saleEmail: string
  settlement: string	// 结算主体
  violationReason: string		// 违规原因
  addition: string		// 补充
  adId: string		// ad_id
  sendDate: string // 发送日期
}

export type IMailReminderListRes = ListData<IMailReminderInfo>

type IMailReminderListParams = {
  saleName: string
  sendStatus: number
  accountId: string
  settlement: string
  start: string
  end: string
  disapprovalAdId: string
}

async function getReminderList (params?: IMailReminderListParams) {
  return read<IMailReminderListRes> (
    'mail_distribution/rad_reminds',
    toggleTime({
      ...params,
      // pageSize: 1000
    }),
    // '查询列表失败'
  )
}

export type ICreateReminderParams = {

} & Omit<IMailReminderInfo, 'id'>

async function createReminder (params: ICreateReminderParams) {
  return post<any> ('mail_distribution/rad_reminds', paramsArray2Str(params), '新建Rad提醒失败')
}

export type IEditReminderParams = {

} & Omit<ICreateReminderParams, 'accountId' | 'radRemindDate' | 'disapprovalAdId'>

async function editReminder (params: IEditReminderParams, id: string) {
  return patch<any> ('mail_distribution/rad_reminds', paramsArray2Str(params), '修改Rad提醒失败', id)
}

async function getReminderDetail (id: string) {
  return read<DetailWithLogs<IMailReminderInfo>> ('mail_distribution/rad_reminds', undefined, '获取Rad提醒详情失败', id )
}


async function batchCreateReminder (params: BatchProcessingParams<ICreateReminderParams>[]) {
  return post<BatchProcessingRes<ICreateReminderParams>> ('mail_distribution/rad_reminds', params )
}

async function batchEditReminder (params: BatchProcessingParams<IEditReminderParams>[]) {
  return patch<BatchProcessingRes<IEditReminderParams>> ('mail_distribution/rad_reminds', params)
}

async function batchDeleteReminder (ids: string[]) {
  return del<any> ('mail_distribution/rad_reminds', ids, '批量删除Rad提醒失败')
}

async function batchCommitReminder (ids: string[]) {
  return post<any> ('mail_distribution/send_rad_reminds', ids, '批量提交Rad提醒失败')
}

async function searchReminderSale (saleName?: string ) {
  return read<MailSaleListItem[]> ('mail_distribution/rad_reminds_search_sales', { saleName }, '获取销售（邮箱）失败' )
}

async function getReminderSaleList (params?: string) {
  const [ res ] = await searchReminderSale(params)
  return res?.map(({ saleName, saleEmail }) => ({ value: saleEmail, title: `${ saleName }【${ saleEmail }】` }))
}





export {
  getReminderList,
  createReminder,
  editReminder,
  batchDeleteReminder,
  getReminderDetail,
  batchCreateReminder,
  batchEditReminder,
  batchCommitReminder,
  searchReminderSale,
  getReminderSaleList,
}
